import { motion } from "framer-motion";
import { Phone, ArrowDown } from "lucide-react";
import { COMPANY, HERO_IMG, STATS } from "../../lib/site";

export const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen overflow-hidden bg-background">
      <div className="absolute inset-0">
        <motion.img
          src={HERO_IMG}
          alt="HVAC technician at work"
          initial={{ scale: 1.15 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
      </div>

      <div className="relative mx-auto flex min-h-screen max-w-[1400px] flex-col justify-center px-5 pb-12 pt-28 md:px-10 md:pb-16 md:pt-32 lg:pb-20">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="mb-5 flex items-center gap-3 font-mono-tech text-[11px] uppercase tracking-[0.3em] text-primary md:mb-6"
        >
          <span className="inline-block h-2 w-2 bg-primary" />
          Portland, OR · Vancouver, WA
        </motion.div>

        <motion.img
          src={COMPANY.logo}
          alt="Maddox Heating and Cooling"
          initial={{ opacity: 0, y: 30, scale: 0.92 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
          className="h-52 w-auto self-start object-contain mix-blend-screen sm:h-60 md:h-72 lg:h-80"
        />

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.7 }}
          className="mt-6 max-w-xl text-base text-muted-foreground md:text-lg"
        >
          Repair &amp; maintenance specialists for furnaces, AC, heat pumps and
          gas inserts. Service only — honest fixes, no upsell.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.05, duration: 0.7 }}
          className="mt-7 flex flex-col gap-4 sm:flex-row"
        >
          <a
            href={COMPANY.phoneHref}
            data-testid="hero-call-cta"
            className="group flex items-center justify-center gap-3 bg-primary px-8 py-4 font-mono-tech text-sm font-bold uppercase tracking-[0.15em] text-primary-foreground transition-colors hover:bg-white hover:text-black"
          >
            <Phone className="h-5 w-5" /> Call {COMPANY.phone}
          </a>
          <a
            href="#contact"
            data-testid="hero-request-cta"
            className="flex items-center justify-center gap-3 border border-white/25 px-8 py-4 font-mono-tech text-sm font-bold uppercase tracking-[0.15em] text-foreground transition-colors hover:border-primary hover:text-primary"
          >
            Request Service
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.3 }}
          className="mt-8 grid grid-cols-2 gap-px border border-white/10 bg-white/10 md:mt-10 md:grid-cols-4"
        >
          {STATS.map((s) => (
            <div key={s.label} className="bg-background p-4 md:p-5">
              <div className="font-display text-3xl text-primary md:text-4xl">{s.value}</div>
              <div className="mt-1.5 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                {s.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 right-5 hidden items-center gap-2 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-muted-foreground md:right-10 md:flex"
      >
        Scroll <ArrowDown className="h-4 w-4 animate-bounce" />
      </motion.div>
    </section>
  );
};
